cc.Class({
    extends: cc.Component,

    properties: {
        mask: cc.Node,
        label: cc.Label,
        totalWidth: 390
    },

    updateProgress (value) {
        this.label.string = (value * 100).toFixed(0) + '%';
        this.mask.width = this.totalWidth * value;
    },

    hide () {
        return new Promise(resolve => {
            const opacity = 0;
            cc.tween(this.node).to(0.5, { opacity }, { easing: 'backInOut' }).
            call(resolve).
            start();
        });
    }
});
